module.exports = __webpack_public_path__ + "static/img/2.0328810.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/my/3/2.png
// module id = vVIj
// module chunks = 1